module.exports = __webpack_public_path__ + "img/img_zy.f3d38626.png";